import { useState, useCallback } from 'react';

/**
 * Hook to force a component re-render or trigger effects.
 * Returns a tuple: [tick, forceUpdate]
 * - tick: a number that increments on each forceUpdate call (use in effect dependencies)
 * - forceUpdate: function to trigger the update
 *
 * @returns [tick, forceUpdate]
 */
function useForceUpdate(): [number, () => void] {
  const [tick, setTick] = useState(0);
  const forceUpdate = useCallback(() => setTick((t) => t + 1), []);
  return [tick, forceUpdate];
}

export default useForceUpdate;
